import * as yup from 'yup';
import { getEmirates } from "../utils/constants";
const emarites = getEmirates();
const phoneRegex =new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
export const profileValidation = yup.object().shape({
    email: yup.string().email('Please enter a valid email').required('Email is required'),
    fullName: yup.string().required('Fullname is required').trim('Fullname should not have spaces around').max(25, `Fullname length should be less than 25`),
   phone: yup.string().required('Phone number is required').trim('Phone number should not have spaces around').matches(phoneRegex, {message: 'Please enter a valid mobile number.'}),
   nationality: yup.string().required('Please select your nationality'),
   gender: yup.string().required('Please select your gender').oneOf(['Male', 'Female'])
});
